var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadImgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_10268",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 46,
    height: 46
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.589844,
    y: 0.589844,
    width: 44.8205,
    height: 44.8205,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_10268)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.92743 39.8078C8.90029 39.8078 8.021 39.442 7.28955 38.7106C6.55811 37.9792 6.19238 37.0999 6.19238 36.0727V9.92743C6.19238 8.90029 6.55811 8.021 7.28955 7.28955C8.021 6.55811 8.90029 6.19238 9.92743 6.19238H26.7351V9.92743H9.92743V36.0727H36.0727V19.265H39.8078V36.0727C39.8078 37.0999 39.442 37.9792 38.7106 38.7106C37.9792 39.442 37.0999 39.8078 36.0727 39.8078H9.92743ZM32.3377 17.3975V13.6625H28.6026V9.92743H32.3377V6.19238H36.0727V9.92743H39.8078V13.6625H36.0727V17.3975H32.3377ZM11.7949 32.3377H34.2052L27.202 23.0001L21.5994 30.4702L17.3975 24.8676L11.7949 32.3377Z",
    fill: "#1C1B1F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadImgIcon);
export default __webpack_public_path__ + "static/media/uploadImgIcon.64d51917b4154ec59ae48e45d727c372.svg";
export { ForwardRef as ReactComponent };